/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Preview_Download_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to download thumbnail: {error}" |
*
* @param {Video_Export_Preview_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_download_failed = /** @type {((inputs: Video_Export_Preview_Download_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Download_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du telechargement de la miniature : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Download des Vorschaubildes fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile scaricare la miniatura: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить миниатюру: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo descargar la miniatura: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`缩略图下载失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`サムネイルのダウンロードに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`थंबनेल डाउनलोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao baixar a miniatura: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to download thumbnail: ${i?.error}`)
});